//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import CardPropertyListValue from '../../components/Card/CardPropertyListValue.vue'

export default {
  components: {
    CardPropertyListValue
  },
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      // warning: true,
      warningText: 'Необходимо уточнить состав ролей для включения сотрудника в группы полевых/офисных сотрудников и корректного отображения в рабочем календаре'
    }
  },
  computed: {
    ...mapGetters({
      roles: 'getRoles',
      user: 'getUser'
    }),
    warning: function () {
      return this.object[this.tabProp.key].every(role => !['brigadier', 'brigademember', 'dispatcher', 'reportchecker', 'officeemployee', 'contractorDispatcher', 'contractorOfficeemployee'].includes(role))
    }
  },
  created: function () {
    this.tabProp.listvalues = this.roles.map(role => {
      return {
        value: role.value,
        name: role.name,
        _accessible: role.editable,
        _disabled: !role.editable // Для Table.vue
      }
    })
    // this.tabProp._prepare(this.user)
  }
}
